import styled from 'styled-components';

const monoStack =
  "'SFMono-Regular', Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace";

export const FieldWrapper = styled.div`
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto;
  gap: 8px;
  height: 100%;
  min-height: 0;
`;

export const CanvasRegion = styled.div`
  min-height: 0;
`;

export const ForecastCard = styled.section`
  border: 1px solid
    ${({ theme }) => (theme.name === 'short' ? 'rgba(255, 255, 255, 0.26)' : 'rgba(0, 0, 0, 0.18)')};
  border-radius: 10px;
  background: ${({ theme }) =>
    theme.name === 'short' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.05)'};
  padding: 8px;
  display: grid;
  gap: 6px;
`;

export const ForecastHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
`;

export const ForecastKicker = styled.span`
  font-family: ${monoStack};
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  opacity: 0.7;
`;

export const ForecastMeta = styled.span`
  font-family: ${monoStack};
  font-size: 10px;
  opacity: 0.56;
`;

export const CurrentState = styled.p`
  margin: 0;
  font-family: ${monoStack};
  font-size: 11px;
  line-height: 1.3;
  opacity: 0.88;
`;

export const ForecastList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 5px;
`;

export const ForecastItem = styled.li`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px 8px;
  align-items: center;
`;

export const ForecastLabel = styled.span`
  font-family: ${monoStack};
  font-size: 10px;
  line-height: 1.2;
  opacity: 0.82;
`;

export const ForecastProb = styled.span`
  font-family: ${monoStack};
  font-size: 10px;
  opacity: 0.64;
`;

export const ForecastTrack = styled.span`
  grid-column: 1 / -1;
  height: 4px;
  border-radius: 999px;
  background: ${({ theme }) =>
    theme.name === 'short' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.14)'};
  overflow: hidden;
`;

export const ForecastFill = styled.span<{ $ratio: number }>`
  display: block;
  height: 100%;
  width: ${({ $ratio }) => `${Math.max(0, Math.min(100, $ratio * 100))}%`};
  background: currentColor;
  opacity: 0.75;
`;

export const EmptyState = styled.p`
  margin: 0;
  font-family: ${monoStack};
  font-size: 10px;
  line-height: 1.35;
  opacity: 0.62;
`;
